import React, { useState, useEffect, useRef } from 'react';

import './VIdeoComplex.scss';

export default function VIdeoComplex({ fields }) {
  const [getItemContentIndex, setGetItemContentIndex] = useState(0);
  const videoRef = useRef(null);

  const handleSelect = (value) => {
    setGetItemContentIndex(value);

    if (!videoRef.current) {
      return;
    }

    if (value === 1) {
      videoRef.current.play();
    } else {
      videoRef.current.pause();
    }
  };

  return (
    <div className="VIdeoComplex">
      <div className="VIdeoComplex_content">
        <video ref={videoRef} src={fields.videoUrl?.value?.href || ''} />

        <section
          className={`${'VIdeoComplex_play'} ${getItemContentIndex === 1 ? 'disabled' : ''}`}
          onClick={() => handleSelect(1)}
        >
          <div className="VIdeoComplex_play_icon"></div>
        </section>
        <section
          className={`${'VIdeoComplex_pause'} ${getItemContentIndex === 0 ? 'disabled' : ''}`}
          onClick={() => handleSelect(0)}
        >
          <div className="VIdeoComplex_pause_icon"></div>
          <div className="VIdeoComplex_pause_icon"></div>
        </section>
      </div>
    </div>
  );
}
